<script>
import _ from 'lodash'
import {getTimeSelectors} from './time-selectors'
import {toasty} from '@/toasty.js'
import mobiscroll from '@mobiscroll/javascript'
import PresentacionesAutomodal from '@/views/Presentaciones/autoform.vue'
import { mapGetters } from 'vuex'

let formatOpt = (data) => {
    return _.map(data, item => {
        return {
            text: item.titulo_extendido,
            value: item.id,
            group: item.categoria
        }
    })
}

let adding = {
    abatimiento: {
        id: null,
        cantidad: null
    },
    alimento: {
        id: null,
        cantidad: null
    }
};

export default {
    name: 'PackagingInputs',
    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        bJumboClass: {
            type: String,
            default: 'mb-0 text-center'
        },
        debug: {
            type: Boolean,
            default: !true
        },
        value: {
            type: Object
        },
        fullCatalog: {
            type: Array,
            required: true
        }
    },
    components: { PresentacionesAutomodal },
    computed: {
        ...mapGetters(['isAdmin']),
        emmitiveForm(){
            let form = _.cloneDeep(this.value);
            form.elementosAbatimientoCFG = _.cloneDeep(this.elementosAbatimientoCFG)
            form.inventarioVinculadoCFG = _.cloneDeep(this.inventarioVinculadoCFG)
            form.duracion_abatimiento_min = _.cloneDeep(this.duracion_abatimiento_min)
            return form;
        },
        abatimientoOPT(){
            return formatOpt(_.filter(this.fullCatalog, {tipo: '2'}))
        },
        alimentosOPT(){
            return formatOpt(_.filter(this.fullCatalog, {tipo: '1'}))
        },
    },
    data: () => {
        return {
            duracion_abatimiento_min: 0,
            elementosAbatimientoCFG: [],
            inventarioVinculadoCFG: [],
            mobis: {
                abatimiento: null,  
                relacionados: null,
            },
            adding: _.cloneDeep(adding)
        }
    },
    methods: {
        getTimeSelectors,
        triggerUpdateEvnt(){
            let data = {
                costo: 0,
                precio: 0
            }
            _.forEach(this.elementosAbatimientoCFG, item => {
                data.costo      += parseInt(item.cantidad) * parseFloat(item.fullObj.costo)
                data.precio     += parseInt(item.cantidad) * parseFloat(item.fullObj.precio)
            })
            this.$emit('updated', data)
        },
        emmitTrigger(){
            this.triggerUpdateEvnt()
            this.$emit('input', this.emmitiveForm)
        },
        rmIndexFrom(id, target){
            try {
                let indexItm = _.findIndex(target, {id});
                if(indexItm == -1){
                    throw 'Elemento no encontrado'
                }
                target.splice(indexItm, 1)
                this.emmitTrigger()
            } catch(e){
                toasty(e)
            }
        },
        addAlimentoItem(){
            try {
                let item2add = _.cloneDeep(this.adding.alimento)
                if(item2add.cantidad <= 0){
                    throw 'La cantidad debe ser mayor a 1';
                }
                let itsOnly = _.findIndex(this.inventarioVinculadoCFG, {id: item2add.id})
                if(itsOnly !== -1){
                    throw 'Ya has agregado la presentacion a la lista';
                }
                item2add.fullObj = _.find(this.fullCatalog, {id: item2add.id})
                this.inventarioVinculadoCFG.push(item2add)
                this.emmitTrigger()
                this.cleanInputs()
            } catch(e){
                console.warn(e)
                toasty(e)
            }
        },
        addAbatimientoItem(){
            try {
                let item2add = _.cloneDeep(this.adding.abatimiento)
                if(item2add.cantidad <= 0){
                    throw 'La cantidad debe ser mayor a 1';
                }
                let itsOnly = _.findIndex(this.elementosAbatimientoCFG, {id: item2add.id})
                if(itsOnly !== -1){
                    throw 'Ya has agregado el artículo a la lista';
                }
                item2add.fullObj = _.find(this.fullCatalog, {id: item2add.id})
                this.elementosAbatimientoCFG.push(item2add)
                this.emmitTrigger()
                this.cleanInputs()
            } catch(e){
                console.warn(e)
                toasty(e)
            }
        },
        loadMobis() {
            this.mobis.abatimiento = mobiscroll.select('#AbatimientoSelect', {
                filter: true,
                inputClass: 'form-control'
            })
            this.mobis.relacionados = mobiscroll.select('#PresentacionSelect', {
                filter: true,
                inputClass: 'form-control'
            })
        },
        cleanInputs(){
            this.adding = _.cloneDeep(adding)
            _.forEach(this.mobis, mobi => {
                if(_.isObjectLike(mobi) && typeof mobi.clear == Function) mobi.clear()
            })
        }
    },
    beforeMount(){
        _.forEach(['inventarioVinculadoCFG', 'elementosAbatimientoCFG'], preLoading => {
            if(_.isArray(this.value[preLoading])){
                this[preLoading] = _.cloneDeep(this.value[preLoading])
            }
        })
        if(this.value.duracion_abatimiento_min){
            this.duracion_abatimiento_min = parseInt(this.value.duracion_abatimiento_min)
        }
    },
    mounted(){
        this.loadMobis()
    },
    watch: {
        readonly(){
            console.log("readonly", this.readonly, this.mobis.abatimiento);
            if(this.readonly && _.isObjectLike(this.mobis.abatimiento) && _.isFunction(this.mobis.abatimiento.destroy)) {
                this.mobis.abatimiento.destroy()
                this.mobis.relacionados.destroy()
            } else if(!this.readonly) {
                this.$nextTick(this.loadMobis)
            } else {
                this.mobis.abatimiento = null;
                this.mobis.relacionados = null;
            }
        }
    }
}
</script>

<template>
    <div id="PackagingInput">

        <b-card id="presentaciones" :no-body="(inventarioVinculadoCFG.length)?true:false">

            <b-jumbotron :class="bJumboClass" v-if="!inventarioVinculadoCFG.length"
                header="Producción incompleta" 
                lead="Agrega las presentaciones que preparaste para avanzar" />

            <b-table class="mb-0" v-else :items="inventarioVinculadoCFG" :fields="['Artículo', 'Cantidad', {key: '_', label: ' '}]">
                <template #cell(Artículo)="data">
                    {{data.item.fullObj.titulo_extendido}}
                </template>
                <template #cell(Cantidad)="data">
                    {{data.item.cantidad}}
                </template>
                <template #cell(_)="data" v-if="!readonly">
                    <b-button size="sm" variant="outline-danger" @click="rmIndexFrom(data.item.id, inventarioVinculadoCFG)"><i class="fa fa-minus"></i></b-button>
                </template>
            </b-table>

            <div  v-if="debug" class="debug"><pre>{{inventarioVinculadoCFG}}</pre></div>

            <template slot="header">
                <b-row align-h="between" align-v="center">
                    <b-col cols="4">
                        Presentaciones a la venta
                    </b-col>
                </b-row>
            </template>

            <template slot="footer" v-if="!readonly">
                <b-form inline>
                    <b-form-select id="PresentacionSelect" :options="alimentosOPT" v-model="adding.alimento.id"/>
                    <b-input-group class="ml-4 mr-4" prepend="A inventario">
                        <b-form-input v-model="adding.alimento.cantidad" type="number" min="0"/>
                    </b-input-group>
                    <b-button :disabled="!adding.alimento.id || !adding.alimento.cantidad" @click="addAlimentoItem" variant="primary">Vincular</b-button>
                </b-form>
            </template>
        </b-card>

        <b-card id="abatimiento" header="Artículos de abatimiento" :no-body="(elementosAbatimientoCFG.length)? true : false" v-if="isAdmin">
            <b-jumbotron :class="bJumboClass" v-if="!elementosAbatimientoCFG.length"
                lead="Abatimientos no agregados" />
            <b-table class="mb-0" v-else :items="elementosAbatimientoCFG" :fields="['Artículo', 'Cantidad', {key: '_', label: ' '}]">
                <template #cell(Artículo)="data">
                    {{data.item.fullObj.titulo_extendido}}
                </template>
                <template #cell(Cantidad)="data">
                    {{data.item.cantidad}}
                </template>
                <template #cell(_)="data"  v-if="!readonly">
                    <b-button size="sm" variant="outline-danger" @click="rmIndexFrom(data.item.id, elementosAbatimientoCFG)"><i class="fa fa-minus"></i></b-button>
                </template>
            </b-table>

            <div  v-if="debug" class="debug"><pre>{{elementosAbatimientoCFG}}</pre></div>

            <template slot="footer" v-if="!readonly">
                <b-form inline>
                    <b-form-select id="AbatimientoSelect" :options="abatimientoOPT" v-model="adding.abatimiento.id"/>
                    <b-input-group class="ml-4 mr-4" prepend="Consumo">
                        <b-form-input v-model="adding.abatimiento.cantidad" type="number" min="0"/>
                    </b-input-group>
                    <b-button :disabled="!adding.abatimiento.id || !adding.abatimiento.cantidad" @click="addAbatimientoItem" variant="primary">Agregar</b-button>
                </b-form>
            </template>
        </b-card>

        <b-row id="duracion_abatimiento" align-h="end" v-if="isAdmin">
            <b-col cols="4">
                <b-form-group label="Duración del abatimiento" label-for="duracion_abatimiento_min" class="pt-3 pb-1">
                    <b-form-select id="duracion_abatimiento_min"  v-model="duracion_abatimiento_min" 
                        :options="getTimeSelectors()"
                        :disabled="readonly"
                        @change="emmitTrigger"/>
                </b-form-group>
            </b-col>
        </b-row>

        <div class="debug" v-if="debug">
            <pre>{{adding.abatimiento}}</pre>
            <pre>{{form}}</pre>
            <pre>{{fullCatalog[0]}}</pre>
        </div>

    </div>
</template>